import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Surveys from "@/pages/Surveys";

export default function App() {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/surveys" element={<Surveys />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        borderRadius: 0,
                        border: '1px solid #0A0A0A',
                        background: '#F2EFE9',
                        color: '#0A0A0A',
                        fontFamily: '"IBM Plex Sans Arabic", sans-serif',
                    },
                }}
            />
        </>
    );
}
